<form-control-container #container [control]="controlInstance" [class.readonly]="isReadonlyValue">

    <div label-extension>
        <ng-content select="[label-extension]"></ng-content>
    </div>
    <ng-container *ngIf="!isReadonlyValue">

        <div class="input-group">
            <loader [show]="isLoading"></loader>
            <div class="input-container">
                <input type="file" [name]="uploadFieldName" (change)="onFilesChange($event.target['name'], $event.target['files'], $event)"
                    [disabled]="isLoading" [attr.multiple]="isMultiple" #files>
                <img src="/assets/images/icons/files/file-icon.svg" class="file-wrapper-icon" />
                <div class="file-wrapper-text">
                  <span>{{ 'Controls.FileInput.DragFilesOr' | translate }}</span>&nbsp;<span class="red">{{ 'Controls.FileInput.BrowseToUpload' | translate }}</span>
                </div>
            </div>
            <div class="attachment-container" *ngIf="attachedFiles && attachedFiles.length">                
                <div class="attachment" *ngFor="let file of attachedFiles">
                    <img src="/assets/images/icons/files/scrape.svg" />
                    <div class="attachment-name" (click)="onAttachmentClick($event, file)" [class.downloaded-file]="!!file.id">{{file.name}}</div>
                    <img class="attachment-remove" src="/assets/images/icons/close_popup_red.svg" (click)="onRemoveAttachment($event, file)" />
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="isReadonlyValue">
        <div class="attachment-container" *ngIf="attachedFiles && attachedFiles.length">
            <div class="attachment" *ngFor="let file of attachedFiles">
                <img src="/assets/images/icons/files/scrape.svg" />
                <div class="attachment-name" (click)="onAttachmentClick($event, file)" [class.downloaded-file]="!!file.id">{{file.name}}</div>
            </div>
        </div>
    </ng-container>
</form-control-container>

<ng-template #fileReadErrors let-data="data">
    <div class="file-read-error" *ngFor="let error of data.errors">{{error}}</div>
</ng-template>
